var host = "https://api-ams.bitflex.xyz/api";


const { h } = require("vue");

module.exports = {
    V1API: {
        'getAccessToken': host + '/authentication/token',
        'refreshAccessToken': host + '/authentication/token/refresh',
        'verifyLogin': host + '/authentication/token/verify',

        // Project ASM
        // Dashboard
        'get_asset_count': host + '/asset/count',
        'get_volunteer_count': host + '/volunteer/type/count',

        // Country
        'country_list': host + '/location/country',
        'create_country': host + '/location/country/create',
        'update_country': host + '/location/country/update/',
        'country_delete': host + '/location/country/delete/',

        // District
        'district_list': host + '/location/district',
        'district_list_by_country': host + '/location/district/read/country/',
        'create_district': host + '/location/district/create',
        'update_district': host + '/location/district/update/',
        'district_delete': host + '/location/district/delete/',

        // Area
        'area_list': host + '/location/area',
        'area_list_by_district': host + '/location/area/read/district/',
        'create_area': host + '/location/area/create',
        'update_area': host + '/location/area/update/',
        'area_delete': host + '/location/area/delete/',

        // Camp
        'camp_list': host + '/location/camp-location',
        'camp_list_by_area': host + '/location/camp-location/read/area/',
        'create_camp': host + '/location/camp-location/create',
        'update_camp': host + '/location/camp-location/update/',
        'camp_delete': host + '/location/camp-location/delete/',

        // Block
        'block_list': host + '/location/block',
        'block_list_by_camp': host + '/location/block/read/camp/',
        'create_block': host + '/location/block/create',
        'update_block': host + '/location/block/update/',
        'block_delete': host + '/location/block/delete/',

        // Asset        
        'create_bulk_asset_qr': host + '/asset/QR/create', 
        'bulk_asset_qr_list': host + '/asset/QR/list', 
        'unmarked_asset_ids': host + '/asset/QR/list/unmarked', 
        'create_asset': host + '/asset/create/by-QR', 
        'update_asset': host + '/asset/edit/',
        'asset_delete': host + '/asset/delete/',
        'asset_list': host + '/asset/list',
        'asset_detail': host + '/asset/details/',
        'create_asset_type': host + '/asset/type/create', //asset type
        'update_asset_type': host + '/asset/type/edit/',
        'asset_type_delete': host + '/asset/type/delete/',
        'asset_type_list': host + '/asset/type/list',
        'asset_type_details': host + '/asset/type/details/',
        'create_asset_type_feature': host + '/asset/feature/create', //asset type feature
        'asset_type_feature_delete': host + '/asset/feature/delete/',
        'assign_user_to_asset': host + '/asset/user/create', // assign user to asset
        'delete_asset_assigned_user': host + '/asset/user/delete/', // delete assigned user from asset
        'asset_add_attachment': host + '/asset/add-attachment', // attachment add
        'asset_delete_attachment': host + '/asset/delete-attachment/', //attachment delete

        // Volunteer
        'create_volunteer_type': host + '/volunteer/type/create', // volunteer type
        'update_volunteer_type': host + '/volunteer/type/edit/',
        'volunteer_type_delete': host + '/volunteer/type/delete/',
        'volunteer_type_list': host + '/volunteer/type/list',
        'volunteer_list': host + '/volunteer/accounts/list', // volunteer list
        'volunteer_list_by_type': host + '/volunteer/by-type?volunteer_type=',
        'volunteer_details': host + '/volunteer/accounts/employee-info/', // volunteer details
        'create_volunteer': host + '/volunteer/accounts/create',
        'update_volunteer': host + '/volunteer/accounts/edit/full/',
        'volunteer_delete': host + '/access-control/user-accounts/delete/',

        // Admin
        'admin_list': host + '/access-control/user-accounts', 
        'create_admin': host + '/access-control/user-accounts/create',
        // 'update_admin': host + '/volunteer/accounts/edit/full/',
        'admin_delete': host + '/access-control/user-accounts/delete/',
        'change_password': host + '/access-control/user-accounts/change-password',

        // Shelter
        'shelter_list': host + '/location/shelter',
        'shelter_details': host + '/location/shelter/details/', 
        'create_shelter': host + '/location/shelter/create',
        'update_shelter': host + '/location/shelter/edit/',
        'shelter_delete': host + '/location/shelter/delete/',

        // House
        'house_list': host + '/home/list/admin-panel/full-list',
        'create_house': host + '/home/register',
        'other_member_delete': host + '/home/delete-listed/other-members',
        'other_member_edit': host + '/home/update-information/other-member/',
        'core_member_edit': host + '/home/update-information/core-member/',

        // Emergency Contact
        'contact_list': host + '/resource/contact',
        'create_contact': host + '/resource/contact/create',
        'update_contact': host + '/resource/contact/edit/',
        'contact_delete': host + '/resource/contact/delete/',

        // Relief
        'relief_list': host + '/resource/relief',
        'create_relief': host + '/resource/relief/create',
        'update_relief': host + '/resource/relief/edit/',
        'relief_delete': host + '/resource/relief/delete/',

        // Occupancy Summary
        'occupancy_summary_list': host + '/disaster-occupancy/all/sorted',

        //Portfolio
        // Blog
        'blog_list':host+'/blog/list',
        'create_blog':host+'/blog/create',
        'get_blog_details':host+'/blog/getdetail/slug',
        'update_blog':host+'/blog/update/',
        'blog_delete':host+'/blog/delete/',

        // Media Appearances
        'media_list':host+'/media_appearance/list',
        'create_media':host+'/media_appearance/create',
        'get_media_details':host+'/media_appearance/detail/slug',
        'update_media':host+'/media_appearance/update/',
        'media_delete':host+'/media_appearance/delete/',

        //Collaboration
        'collaboration_list':host+'/collaboration/list',
        'create_collaboration':host+'/collaboration/create',
        'get_collaboration_details':host+'/collaboration/getdetail/',
        'update_collaboration':host+'/collaboration/update/',
        'collaboration_delete':host+'/collaboration/delete/',

        // Gallery
        'gallery_list':host+'/gallery/list',
        'create_gallery':host+'/gallery/create',
        'get_gallery_details':host+'/gallery/detail/',
        'update_gallery':host+'/gallery/update/',
        'gallery_delete':host+'/gallery/delete/',

        //Publications
        'publication_list':host+'/publication/',
        'create_publication':host+'/publication/create',
        'get_publication_details':host+'/publication/detail/',
        'update_publication':host+'/publication/update/',
        'publication_delete':host+'/publication/delete/',
        'publication_category':host+'/publication/category/list',

        // Recents
        'recent_list':host+'/recent/list',
        'create_recent':host+'/recent/create',
        'get_recent_details':host+'/recent/getdetail/',
        'update_recent':host+'/recent/update/',
        'recent_delete':host+'/recent/delete/',
    }
};
